// extracted by mini-css-extract-plugin
export default {"link":"MenuNav_link__nKjN1","linkAtivo":"MenuNav_linkAtivo__n+I0Z"};